
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 6.959l.998-.99L19.03 19.002l-.99.998-3.765-3.765-2.034 2.035a3.9 3.9 0 01-5.511 0 3.9 3.9 0 010-5.512l1.161-1.161c-.008.639.094 1.278.312 1.894l-.367.366a2.324 2.324 0 000 3.306c.913.92 2.394.92 3.306 0l2.042-2.027-1.263-1.255a.832.832 0 01-.226.53.786.786 0 01-1.107 0 3.876 3.876 0 01-1.13-2.986L5 6.96zm8.349-.819a3.9 3.9 0 015.51 0 3.9 3.9 0 010 5.511l-1.16 1.162a5.385 5.385 0 00-.312-1.887l.366-.374c.92-.912.92-2.393 0-3.305a2.324 2.324 0 00-3.305 0l-2.596 2.596-1.1-1.107L13.35 6.14zM13.894 10a.786.786 0 011.107 0 3.896 3.896 0 01.96 3.944l-1.388-1.38a2.272 2.272 0 00-.679-1.457.759.759 0 010-1.107z","fill":"currentColor"}})])
          )
        }
      }
    